import type { PortalProductType } from "./portal.types";

// Allowlist de destino pro handoff de token da entrada fria por produto
// (?product=X&return_to=Y). Mesmo padrão já em produção no dashboard-web
// (apps/seller-hermes/src/store/login/login.store.ts, isValidRedirectUri) —
// replicado aqui por consistência, não uma invenção nova. Testa contra
// `origin` (protocolo+host, sem path/query) então não dá pra escapar via
// `abbiamolog.com.evil.com` — o `$` ancora o fim exatamente em
// `abbiamolog.com`.
const ALLOWED_ORIGINS = /^https:\/\/([\w-]+\.)*abbiamolog\.com$/;
const ALLOWED_ORIGINS_DEV = /^https?:\/\/localhost(:\d+)?$/;

export const isValidReturnTo = (uri: string): boolean => {
  try {
    const { origin } = new URL(uri);
    if (ALLOWED_ORIGINS.test(origin)) return true;
    if (process.env["NX_ENV"] === "LOCAL" && ALLOWED_ORIGINS_DEV.test(origin)) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

// Reaproveita o mesmo enum que products[].product já usa (LOG-466/467) — não
// inventa um vocabulário novo pro parâmetro de query string.
const COLD_ENTRY_PRODUCTS: readonly PortalProductType[] = ["INSIGHTS", "ROUTING", "VENANCIO_CTE_RECON"];

export const isPortalColdEntryProduct = (
  value: string | null,
): value is PortalProductType =>
  value !== null && (COLD_ENTRY_PRODUCTS as readonly string[]).includes(value);
